export default __webpack_public_path__ + "images/b5a000638788df18bfad46bde98470a7.png";